<template>
    <div>
        <el-dialog :visible.sync="addOrEditDia" width="70%" top="60px" class="formDia" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" @close="diaClosed">
            <div class="dialog-title-container" slot="title" ref="addOrEditTitle"/>
            <el-steps :active="active" finish-status="success" v-if="!editMetadata">
                <el-step title="选择创建方式"></el-step>
                <el-step title="创建元数据"></el-step>
                <el-step title="创建完成"></el-step>
            </el-steps>
            <div v-if="active==0" style="margin-top: 50px">
                <h3>创建方式</h3>
                <el-radio v-model="metadataForm.createMethod" label="1">表单创建</el-radio>
                <el-radio v-model="metadataForm.createMethod" label="2">DDL创建</el-radio>
            </div>
            <div class="step_content" v-if="active==1" v-loading="editLoading">
                <h3>基础信息</h3>
                <el-form :model="metadataForm" label-width="110px" ref="metadataRef" :rules="metadataRules">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="数据源类型" prop="dataSourceType">
                                <el-select v-model="metadataForm.dataSourceType" placeholder="请选择" @change="dataSourceTypeChange" :disabled="editMetadata">
                                    <el-option v-for="(item,index) in dataSourceTypeOptinons" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据源名称" prop="metaDataSourceId">
                                <el-select v-model="metadataForm.metaDataSourceId" placeholder="请选择" @change="metaDataSourceIdChange" value-key="id" :disabled="editMetadata">
                                    <el-option v-for="(item,index) in metaDataSourceIdOptions" :label="item.name" :value="{id:item.id,md5Id:item.md5Id}"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据库名称" prop="dataBaseId">
                                <el-select v-model="metadataForm.dataBaseId" placeholder="请选择" :disabled="editMetadata">
                                    <el-option v-for="(item,index) in dataBaseIdOptions" :label="item.dataBaseName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="更新频率" clearable prop="updateFrequency">
                                <el-select v-model="metadataForm.updateFrequency" :disabled="!frequencyEdit&&editMetadata" placeholder="请选择">
                                    <el-option v-for="(item,index) in updateFrequencyOptions" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                </el-select>

                                <el-button type="primary" @click="handleFrequencyEdit" style="margin: 0 20px" size="small" v-if="editMetadata">
                                    {{frequencyEdit?'完成':'编辑更新频率'}}
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item label="元数据标签" multiple clearable prop="metaLabels">

                                <!--                        <el-select v-model="metadataForm.metaLabels" placeholder="请选择" value-key="labelName"  multiple :disabled="!labelEdit&&editMetadata">-->
                                <!--                            <el-option v-for="(item,index) in metaLabelsOptions" :key="item.labelName" :label="item.labelName" :value="{id:item.id,labelName:item.labelName}"></el-option>-->
                                <!--                        </el-select>-->

                                <el-cascader v-model="metadataForm.metaLabels" :disabled="!labelEdit&&editMetadata" :show-all-levels="false" :options="metaLabelsOptions" :props="{value:'md5Id',label:'labelName',multiple:true,checkStrictly: true}" placeholder="请选择"></el-cascader>

                                <el-button type="primary" @click="handleLableEdit" style="margin: 0 20px" size="small" v-if="editMetadata">
                                    {{labelEdit?'完成':'编辑标签'}}
                                </el-button>
                                <span>负责人:{{realName}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="备注">
                        <el-input v-model="metadataForm.tableDesc" placeholder="120字以内" style="width: 660px" type="textarea" maxlength="120"></el-input>
                    </el-form-item>
                    <h3>{{metadataForm.createMethod=='1'?'表信息':'SQL语句'}}</h3>
                    <div v-if="metadataForm.dataSourceType=='hive'&&metadataForm.createMethod=='1'">
                        <!--                        <el-form-item label="存储路径">-->
                        <!--                            <el-col :span="2">-->
                        <!--                                <el-switch disabled v-model="tableSave"></el-switch>-->
                        <!--                            </el-col>-->
                        <!--                            <el-col :span="5">-->
                        <!--                                <el-input v-if="!tableSave" :disabled="editMetadata" v-model="metadataForm.metaTable.tableStorage" style="width: 200px"></el-input>-->
                        <!--                                <el-input v-else v-model="metadataForm.metaTable.tableStorage" :disabled="editMetadata" style="width: 200px"></el-input>-->
                        <!--                            </el-col>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="表分组">
                            <el-radio v-model="metadataForm.metaTable.tableType" label="" :disabled="editMetadata">外部表
                            </el-radio>
                            <el-radio v-model="metadataForm.metaTable.tableType" label="external_table" :disabled="editMetadata">
                                内部表
                            </el-radio>
                        </el-form-item>
                        <el-row>
                            <el-col :span="9">
                                <el-form-item label="存储格式" :prop="'metaTable.tableStorageFormat'" :rules="metadataRules.tableStorageFormat">
                                    <el-select v-model="metadataForm.metaTable.tableStorageFormat" placeholder="请选择" :disabled="editMetadata">
                                        <el-option v-for="(item,index) in tableStorageFormatOptinons" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="9" v-if="metadataForm.metaTable.tableStorageFormat=='textfile'">
                                <el-form-item label="字段划分格式" prop="tableDivisionFormat">
                                    <el-input :disabled="editMetadata" placeholder="通常为空格、”\t”、”\x001″" v-model="metadataForm.metaTable.tableDivisionFormat"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="tableName">
                            <template v-if="metadataForm.metaTable.oldFlag">
                                <el-form-item label="表名" :prop="'metaTable.tableName'">
                                    <el-input placeholder="表名" v-model="metadataForm.metaTable.tableName" style="width: 300px"></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item label="表名" :prop="'metaTable.hiveLayered'" :rules="metadataRules.hiveLayered">
                                    <el-select v-model="metadataForm.metaTable.hiveLayered" placeholder="表分层" style="width: 100px" :disabled="editMetadata">
                                        <el-option v-for="(item,index) in hiveLayeredOptions" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :prop="'metaTable.hiveTableName'" :rules="metadataRules.hiveTableName" label-width="0px">
                                    <el-input placeholder="表名" v-model="metadataForm.metaTable.hiveTableName" style="width: 300px"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'metaTable.hiveSyncType'" :rules="metadataRules.hiveSyncType" label-width="0px">
                                    <el-select v-model="metadataForm.metaTable.hiveSyncType" placeholder="增/全量" :disabled="editMetadata">
                                        <el-option v-for="(item,index) in hiveSyncTypeOptions" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :prop="'metaTable.hivePartition'" :rules="metadataRules.hivePartition" label-width="0px">
                                    <el-select v-model="metadataForm.metaTable.hivePartition" placeholder="分区" style="width: 100px" :disabled="editMetadata">
                                        <el-option v-for="(item,index) in hivePartitionOptions" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </div>
                        <div>
                            <el-table class="grayTableTile_01" :data="metadataForm.metaColumns" border style="width: 100%">
                                <el-table-column width="40">
                                    <template slot-scope="scope">
                                        <el-link @click="deleteColumn(scope,1)" :disabled="editMetadata&&'oldIndex' in scope.row" :underline="false">
                                            <i class="el-icon-delete"></i></el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                <el-table-column label="字段名">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaColumns.'+scope.$index+'.columnName'" :rules="metadataRules.columnName" label-width="0px">
                                            <el-input v-model="scope.row.columnName" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段描述">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaColumns.'+scope.$index+'.columnDesc'" :rules="metadataRules.columnDesc" label-width="0px">
                                            <el-input v-model="scope.row.columnDesc" maxlength="200" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段类型" width="140">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaColumns.'+scope.$index+'.columnType'" :rules="metadataRules.columnType" label-width="0px">
                                            <el-select v-model="scope.row.columnType" placeholder="请选择" :disabled="editMetadata&&'oldIndex' in scope.row">
                                                <el-option v-for="(item,index) in columnTypeOptions" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段长度" width="120">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0px">
                                            <el-input v-model="scope.row.columnLength" type="number" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button class="add_but" type="primary" @click="metadataForm.metaColumns.push({columnName: '',columnDesc: '',columnType: '',columnLength: '',columnIfPartition: 1,flag:1})">
                                加字段
                            </el-button>
                            <el-table class="grayTableTile_01" :data="metadataForm.metaPartColumns" border style="width: 100%">
                                <el-table-column width="40">
                                    <template slot-scope="scope">
                                        <el-link @click="deleteColumn(scope,0)" :disabled="editMetadata&&'oldIndex' in scope.row" :underline="false">
                                            <i class="el-icon-delete"></i></el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                <el-table-column label="字段名">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaPartColumns.'+scope.$index+'.columnName'" :rules="metadataRules.columnName" label-width="0px">
                                            <el-input v-model="scope.row.columnName" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段描述">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaPartColumns.'+scope.$index+'.columnDesc'" :rules="metadataRules.columnDesc" label-width="0px">
                                            <el-input v-model="scope.row.columnDesc" maxlength="200" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段类型" width="140">
                                    <template slot-scope="scope">
                                        <el-form-item :prop="'metaPartColumns.'+scope.$index+'.columnType'" :rules="metadataRules.columnType" label-width="0px">
                                            <el-select v-model="scope.row.columnType" placeholder="请选择" :disabled="editMetadata&&'oldIndex' in scope.row">
                                                <el-option v-for="(item,index) in columnTypeOptions" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="字段长度" width="120">
                                    <template slot-scope="scope">
                                        <el-form-item label-width="0px">
                                            <el-input v-model="scope.row.columnLength" type="number" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button class="add_but" :disabled="editMetadata" type="primary" v-if="metadataForm.metaPartColumns.length<3" @click="metadataForm.metaPartColumns.push({isPrimary:0,columnName: '',columnDesc: '',columnType: '',columnLength: '',columnIfPartition:0,flag:1})">
                                加分区字段
                            </el-button>
                        </div>
                    </div>
                    <div v-else-if="metadataForm.dataSourceType=='mysql'&&metadataForm.createMethod=='1'">
                        <div class="tableName">
                            <el-form-item label="表名" :prop="'metaTable.mysqlTableName'" :rules="metadataRules.mysqlTableName">
                                <el-input placeholder="表名" v-model="metadataForm.metaTable.mysqlTableName" style="width: 500px"></el-input>
                            </el-form-item>
                        </div>

                        <el-table class="grayTableTile_01" :data="metadataForm.metaColumns" border style="width: 100%" row-key="uuid">
                            <el-table-column width="40">
                                <template slot-scope="scope">
                                    <el-link @click="deleteColumn(scope)" :underline="false">
                                        <i class="el-icon-delete"></i></el-link>
                                </template>
                            </el-table-column>
                            <el-table-column width="60">
                                <span :class="[{'move':!editMetadata},{'un_move':editMetadata}]"><i class="el-icon-rank"></i></span>
                            </el-table-column>
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column label="主键" width="50">
                                <template slot-scope="scope">
                                    <el-checkbox :true-label=1 :false-label=0 v-model="scope.row.isPrimary" @change="primaryChange(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="字段名">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaColumns.'+scope.$index+'.columnName'" :rules="metadataRules.columnName" label-width="0px">
                                        <el-input v-model="scope.row.columnName" @change="currencyChange(scope.row)"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="字段描述">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaColumns.'+scope.$index+'.columnDesc'" :rules="metadataRules.columnDesc" label-width="0px">
                                        <el-input v-model="scope.row.columnDesc" maxlength="200" @change="currencyChange(scope.row)"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="字段类型" width="140">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaColumns.'+scope.$index+'.columnType'" :rules="metadataRules.columnType" label-width="0px">
                                        <el-select v-model="scope.row.columnType" placeholder="请选择" @change="columnTypeChange(scope.row)">
                                            <el-option v-for="(item,index) in mysqlTypeOptions" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="字段长度" width="120">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaColumns.'+scope.$index+'.columnLength'" :rules="metadataRules.columnLength" label-width="0px">
                                        <el-input v-model="scope.row.columnLength" type="number" @change="currencyChange(scope.row)" :placeholder=getPlace(scope)></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="默认值" width="120">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaColumns.'+scope.$index+'.defaultValue'" :rules="metadataRules.defaultValue" label-width="0px">
                                        <el-input v-model="scope.row.defaultValue" @change="currencyChange(scope.row)"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="自增" width="50">
                                <template slot-scope="scope">
                                    <el-checkbox :true-label=0 :false-label=1 v-model="scope.row.columnIfIncy" @change="currencyChange(scope.row)" :disabled="scope.row.columnType!='INT'&&scope.row.columnType!='BIGINT'&&scope.row.columnType!='bigint'"></el-checkbox>
                                </template>
                            </el-table-column>

                            <el-table-column label="是否允许为空" width="120">
                                <template slot-scope="scope">
                                    <el-form-item label-width="0px">
                                        <el-switch :disabled="scope.row.isPrimary==1" v-model="scope.row.columnIfNull" @change="currencyChange(scope.row)" :active-value=0 :inactive-value=1></el-switch>
                                    </el-form-item>
                                </template>
                            </el-table-column>

                        </el-table>
                        <el-button class="add_but" type="primary" @click="metadataForm.metaColumns.push({uuid:Number(Math.random().toString().substr(3,5) + Date.now()).toString(36),columnName: '',columnDesc: '',columnType: '',columnLength: '',columnIfIncy: 1,columnIfNull:0,flag:1,isPrimary: 0})">
                            加字段
                        </el-button>

                        <el-table class="grayTableTile_01" :data="metadataForm.metaMysqlIndexUpdateVos" border style="width: 100%" row-key="uuid">
                            <el-table-column width="40">
                                <template slot-scope="scope">
                                    <el-link @click="deleteColumn(scope,'index')" :underline="false">
                                        <i class="el-icon-delete"></i></el-link>
                                </template>
                            </el-table-column>
                            <el-table-column width="60">
                                <span :class="[{'move':!editMetadata},{'un_move':editMetadata}]"><i class="el-icon-rank"></i></span>
                            </el-table-column>
                            <el-table-column label="序号" type="index" width="50"></el-table-column>
                            <el-table-column label="索引类型" width="140">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaMysqlIndexUpdateVos.'+scope.$index+'.indexType'" :rules="metadataRules.indexType" label-width="0px">
                                        <el-select v-model="scope.row.indexType" placeholder="请选择" @change="indexTypeChange(scope.$index,scope.row)" :disabled="editMetadata&&'oldIndex' in scope.row">
                                            <el-option v-for="(item,index) in indexTypeOptions" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="索引字段" width="220">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaMysqlIndexUpdateVos.'+scope.$index+'.metaColumns'" :rules="metadataRules.metaColumns" label-width="0px">
                                        <el-select v-model="scope.row.metaColumns" :multiple="scope.row.indexType==4" clearable placeholder="请选择" @change="currencyChange(scope.row)" :disabled="editMetadata&&'oldIndex' in scope.row">
                                            <el-option v-for="(item,index) in metaColumnsOptions" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>

                            <el-table-column label="索引名称">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaMysqlIndexUpdateVos.'+scope.$index+'.indexName'" :rules="metadataRules.indexName" label-width="0px">
                                        <el-input v-model="scope.row.indexName" @change="currencyChange(scope.row)" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="索引方法" width="120">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'metaMysqlIndexUpdateVos.'+scope.$index+'.indexMethod'" :rules="metadataRules.indexMethod" label-width="0px">
                                        <el-select v-model="scope.row.indexMethod" placeholder="请选择" @change="currencyChange(scope.row)" :disabled="editMetadata&&'oldIndex' in scope.row">
                                            <el-option v-for="(item,index) in indexMethodOptions" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="索引描述">
                                <template slot-scope="scope">
                                    <el-form-item label-width="0px">
                                        <el-input v-model="scope.row.indexDesc" @change="currencyChange(scope.row)" :disabled="editMetadata&&'oldIndex' in scope.row"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>

                        </el-table>
                        <el-button class="add_but" type="primary" v-if="metadataForm.metaMysqlIndexUpdateVos.length<16" @click="metadataForm.metaMysqlIndexUpdateVos.push({uuid:Number(Math.random().toString().substr(3,5) + Date.now()).toString(36),indexType: 2,indexName: '',indexMethod: 'BTREE',indexDesc: '',metaColumns: [],flag:1})">
                            加索引字段
                        </el-button>
                    </div>
                    <div v-else-if="metadataForm.dataSourceType=='doris'&&metadataForm.createMethod=='1'">
                        <div v-if="seeMetadata">
                            <el-table class="grayTableTile_01" :data="metadataForm.metaColumns" border style="width: 100%;">
                                <el-table-column label="基础字段" prop="columnName"></el-table-column>
                                <el-table-column label="字段类型" prop="columnType"></el-table-column>
                            </el-table>
                            <el-divider></el-divider>
                            <el-table class="grayTableTile_01" :data="metadataForm.indexColums" border style="width: 100%">
                                <el-table-column label="索引字段" prop="columnName"></el-table-column>
                                <el-table-column label="字段类型" prop="columnType"></el-table-column>
                            </el-table>
                            <el-divider></el-divider>
                            <el-table class="grayTableTile_01" :data="metadataForm.partColums" border style="width: 100%">
                                <el-table-column label="分区字段" prop="columnName"></el-table-column>
                                <el-table-column label="字段类型" prop="columnType"></el-table-column>
                            </el-table>
                            <!--                            <el-button class="add_but" type="primary">-->
                            <!--                                修改-->
                            <!--                            </el-button>-->
                        </div>
                        <div v-else-if="!seeMetadata&&editMetadata">
                            <el-input v-model="metadataForm.ddl" placeholder="请输入对应的SQL语句" style="" type="textarea" :rows="5"></el-input>
                        </div>
                        <div v-else>
                            <div style="font-size: 15px;margin-left: 10%;display: flex;align-items: center">
                                <i class="el-icon-warning" style="font-size: 20px;color: rgb(255,150,62);margin-right: 10px"></i>doris数据源类型暂时不支持表单创建，请返回上一步选择DDL创建方式
                            </div>
                        </div>
                    </div>
                    <div v-else-if="metadataForm.createMethod=='2'">
                        <el-input v-model="metadataForm.ddl" placeholder="请输入对应的SQL语句" style="" type="textarea" :rows="5"></el-input>
                    </div>
                </el-form>
            </div>
            <div class="step_content" v-else-if="active==2">
                <div class="step_3">
                    <span class="iconfont icon-chenggong" style="color: #24915a;font-size: 50px"></span>
                    <div class="title">创建成功</div>
                    <div class="content" v-if="metadataForm.createMethod=='1'">
                        <div class="table_name">
                            <span>元数据表名</span> <span>{{metadataForm.dataSourceType=='hive'?metadataForm.metaTable.hiveTableName:metadataForm.metaTable.mysqlTableName}}</span>
                        </div>
                        <div class="table_index">
                            <span>元数据表字段</span> <span class="index_item" v-for="item in metadataForm.metaColumns">{{metadataForm.dataSourceType=='hive'?item.columnIfPartition==1?item.columnName:'':item.columnName}}</span>
                        </div>
                    </div>
                    <div class="bottom_button" v-if="metadataForm.createMethod=='1'">
                        <el-button type="primary" @click="ddlDia=true">查看DDL语句</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDia">{{active==2?'关闭':'取消'}}</el-button>
                <!--                <el-button @click="active&#45;&#45;" v-if="active==1&&!editMetadata">上一步</el-button>-->
                <el-button type="primary" v-if="active==0" @click="active++">下一步</el-button>
                <el-button type="primary" v-if="active==1&&!editMetadata" @click="handleAdd">开始创建</el-button>
                <el-button type="primary" v-if="editMetadata&&!seeMetadata" @click="handleEdit">修改</el-button>
            </span>
            <el-dialog width="70%" title="DDL语句" :visible.sync="ddlDia" append-to-body>
                <span v-html="ddl" style="white-space: pre-wrap"></span>
            </el-dialog>
        </el-dialog>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'
    import draggable from 'vuedraggable'
    import Sortable from 'sortablejs'
    import {
        queryLabelBy,
        create_byForm,
        create_byDdl,
        queryBy_dbtype,
        queryBy_md5Id,
        queryBy_datas,
        deleteBy_datas,
        update_byForm,
        update_byDdl,
        update_label,
        update_frequency
    } from '@Dcs~/api/metadataList_model'
    import config from '@Dcs~/views/dataManage/metadataManage/metadataList/mixins/config'

    export default {
        name: 'MetadataDialog',
        mixins: [config],
        data() {

            return {
                editLoading: false,
                tableSave: true,
                addOrEditDia: false,
                editMetadata: false,
                seeMetadata: false,
                active: 0,
                ddl: '',
                ddlDia: false,
                labelEdit: false,
                frequencyEdit: false
            }
        },
        watch: {
            // 'metadataForm.metaTable.tableType'(newVal, oldVal) {
            //   if (newVal == 'external_table') {
            //     this.tableSave = false
            //     this.metadataForm.metaTable.tableStorage = '/user/hive/warehouse'
            //   } else {
            //     this.tableSave = true
            //     this.metadataForm.metaTable.tableStorage = ''
            //   }
            // }
        },

        computed: {
            ...mapGetters([
                'realName'
            ]),
            metaColumnsOptions() {
                let options = []
                var flag = new RegExp('[`~!@#$^&*()=|{}\':;\',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？ ]')
                this.metadataForm.metaColumns.forEach((item) => {
                    if (item.columnName != '' && (/^[a-zA-Z]/).test(item.columnName) && !flag.test(item.columnName)) {
                        options.push(item.columnName)
                    }
                })
                options = [...new Set(options)].map((item) => {
                    return { label: item, value: item }
                })
                return options
            }
        },
        methods: {
            init(type) {
                queryLabelBy().then((res) => {
                    if (res.code == 1) {
                        this.metaLabelsOptions = res.data
                        //先把标签接口请求好
                    }
                })
                this.metadataForm = this.$options.data.call(this).metadataForm
                this.metadataForm.metaTable.id = type.id
                this.metadataForm.metaTable.onlineStatus = type.onlineStatus
                if (type == 'add') {
                    this.addOrEditDia = true
                    this.editMetadata = false
                    this.$refs.addOrEditTitle.innerHTML = '添加元数据'
                    this.metadataForm.createMethod = '2'
                    this.active = 1
                    this.$nextTick(()=>{
                        this.$refs.metadataRef.resetFields()
                    })
                } else {
                    this.addOrEditDia = true
                    this.editMetadata = true
                    this.active = 1
                    this.$refs.addOrEditTitle.innerHTML = this.seeMetadata ? '查看元数据' : '修改元数据'
                    this.editLoading = true
                    queryBy_datas(type.id).then((res) => {
                        if (res.code == 1) {
                            this.metadataForm.createMethod = '1'
                            this.metadataForm.metaTable = res.data.metaTable
                            this.metadataForm.md5Id = res.data.metaTable.md5Id
                            this.metadataForm.dataSourceType = res.data.metaTable.dataSourceType
                            this.metadataForm.metaDataSourceId = res.data.metaTable.dataSourceName
                            this.metadataForm.dataBaseId = res.data.metaTable.dataBaseName
                            this.metadataForm.updateFrequency = res.data.metaTable.updateFrequency
                            this.metadataForm.sendSourceId = res.data.metaDataSourceId
                            this.metadataForm.sendBaseId = res.data.dataBaseId
                            this.metadataForm.metaLabels = res.data.labelIds
                            this.metadataForm.tableDesc = res.data.metaTable.tableDesc
                            if (this.metadataForm.dataSourceType == 'mysql') {
                                this.$nextTick(() => {
                                    this.drag()
                                })
                                // this.metadataForm.metaTable.mysqlSyncType = res.data.metaTable.mysqlSyncType
                                // this.metadataForm.metaTable.mysqlTableName = res.data.metaTable.mysqlTableName
                                //TODO mysql表的第二个字段还要赋值
                                this.metadataForm.metaColumns = res.data.metaColumns.map((item, index) => {
                                    item.oldIndex = index
                                    item.uuid = this.setUUid()
                                    if (!item.columnIfIncy && item.columnIfIncy !== 0) {
                                        this.$set(item, 'columnIfIncy', 1)
                                    }
                                    return item
                                })
                                this.metadataForm.metaMysqlIndexUpdateVos = res.data.metaMysqlIndexUpdateVos.map((item, index) => {
                                    item.oldIndex = index
                                    item.uuid = this.setUUid()
                                    item.metaColumns = item.metaColumns.map((item2) => {
                                        return item2.columnName
                                    })
                                    if (item.indexType != 4) {
                                        item.metaColumns = item.metaColumns.join()
                                    }
                                    return item
                                })
                                console.log(this.metadataForm.metaColumns)

                            } else if (this.metadataForm.dataSourceType == 'hive') {
                                this.metadataForm.metaColumns = res.data.metaColumns.map((item, index) => {
                                    if (!(item.columnIfPartition == 0)) {
                                        item.columnIfPartition = 1
                                    }
                                    item.uuid = this.setUUid()
                                    item.oldIndex = index
                                    return item
                                })
                                this.metadataForm.metaPartColumns = this.metadataForm.metaColumns.filter(item => item.columnIfPartition == 0)
                                this.metadataForm.metaColumns = this.metadataForm.metaColumns.filter(item => item.columnIfPartition == 1)
                            } else if (this.metadataForm.dataSourceType == 'doris') {
                                this.metadataForm.createMethod = this.seeMetadata ? '1' : '2'
                                this.metadataForm.metaTableId = type.id
                                this.metadataForm.metaColumns = res.data.metaColumns
                                this.metadataForm.partColums = res.data.metaColumns.filter(item => item.columnIfPartition == 0)
                                this.metadataForm.indexColums = res.data.metaMysqlIndexUpdateVos.map(item => item.metaColumns[0])
                            }
                        }
                        this.editLoading = false
                    })

                }
            },
            setUUid() {
                return Number(Math.random().toString().substr(3, 5) + Date.now()).toString(36)
            },
            //标签接口单独请求
            handleLableEdit() {
                if (this.labelEdit) {
                    this.labelEdit = false
                    //编辑标签
                    update_label({
                        md5Id: this.metadataForm.md5Id,
                        labelIds: this.metadataForm.metaLabels
                    }).then((res) => {
                        if (res.code == 1) {
                            console.log('编辑成功')
                        }
                    })
                } else {
                    this.labelEdit = true
                }
            },

            //更新频率修改单独接口
            handleFrequencyEdit() {
                if (this.frequencyEdit) {
                    this.frequencyEdit = false
                    //编辑更新频率
                    update_frequency({
                        md5Id: this.metadataForm.md5Id,
                        updateFrequency: this.metadataForm.updateFrequency
                    }).then((res) => {
                        if (res.code == 1) {
                            console.log('编辑成功')
                        }
                    })
                } else {
                    this.frequencyEdit = true
                }
            },
            //添加
            handleAdd() {
                let param = this.formatData()
                console.log(param)
                param.metaDataSourceId = param.metaDataSourceId.id
                // this.active++
                this.$refs['metadataRef'].validate((valid) => {
                    if (valid) {
                        if (param.createMethod == '1') {
                            create_byForm(param).then((res) => {
                                if (res.code == 1) {
                                    this.ddl = res.msg
                                    this.$message({ message: '添加成功', type: 'success' })
                                    this.active++
                                }
                            })
                        } else {
                            create_byDdl(param).then((res) => {
                                if (res.code == 1) {
                                    this.ddl = res.msg
                                    this.$message({ message: '添加成功', type: 'success' })
                                    this.active++
                                }
                            })
                        }
                    }
                })
            },
            //编辑
            handleEdit() {
                let param = this.formatData()
                this.$refs['metadataRef'].validate((valid) => {
                    if (valid) {
                        param.metaDataSourceId = param.sendSourceId
                        param.dataBaseId = param.sendBaseId
                        if (param.createMethod == '1') {
                            update_byForm(param).then((res) => {
                                if (res.code == 1) {
                                    this.$message({ message: '修改成功', type: 'success' })
                                    this.addOrEditDia = false
                                    this.$emit('closeDia')
                                }
                            })
                        } else {
                            update_byDdl(param).then((res) => {
                                if (res.code == 1) {
                                    this.$message({ message: '修改成功', type: 'success' })
                                    this.addOrEditDia = false
                                    this.$emit('closeDia')
                                }
                            })
                        }
                    } else {
                        console.log('nook')
                    }
                })
            },
            //删除字段或索引
            deleteColumn(scope, type) {
                console.log(scope)
                //除了编辑时要特殊控制下 其他情况直接删除就行
                //这里如果要把删除的索引传给后台的话 还要对点击编辑后拿到的列表数据加一个特定oldIndex
                let i = 0
                if (type == 'index') {
                    //删除mysql索引字段
                    if (this.editMetadata && 'oldIndex' in scope.row) {
                        this.metadataForm.deleteIndexIds.push(scope.row.id)
                    }
                    this.metadataForm.metaMysqlIndexUpdateVos.splice(scope.$index, 1)
                } else if (type == 0) {
                    //删除hive字段
                    if (this.editMetadata && 'oldIndex' in scope.row) {
                        this.metadataForm.deleteColumnIds.push(scope.row.id)
                    }
                    this.metadataForm.metaPartColumns.splice(scope.$index, 1)
                } else {
                    //删除mysql字段
                    if (this.editMetadata && 'oldIndex' in scope.row) {
                        this.metadataForm.deleteColumnIds.push(scope.row.id)
                    }
                    this.metadataForm.metaColumns.splice(scope.$index, 1)
                }
            },
            closeDia() {
                this.addOrEditDia = false
                this.$emit('closeDia')
            },

            //弹窗关闭回调
            diaClosed() {
                this.labelEdit = false
                this.frequencyEdit = false

            },
            //索引类型变化时--组合索引和其他索引
            indexTypeChange(index, row) {
                if (row.indexType == 4) {
                    this.metadataForm.metaMysqlIndexUpdateVos[index].metaColumns = []
                } else {
                    this.metadataForm.metaMysqlIndexUpdateVos[index].metaColumns = ''
                }
                if ('oldIndex' in row && row.flag != 2) {
                    row.flag = 2
                }
            },

            //数据源类型变化时
            dataSourceTypeChange(val) {
                if (val == 'mysql' && this.metadataForm.createMethod == '1') {
                    this.$nextTick(() => {
                        this.drag()
                    })
                }
                let createMethod = this.metadataForm.createMethod
                this.metadataForm = this.$options.data.call(this).metadataForm
                this.metadataForm.createMethod = createMethod
                this.$refs['metadataRef'].resetFields()
                this.metadataForm.dataSourceType = val
                queryBy_dbtype(val).then((res) => {
                    if (res.code == '1') {
                        this.metaDataSourceIdOptions = res.data
                    }
                })
            },

            //数据源名称变化时
            metaDataSourceIdChange() {
                this.metadataForm.dataBaseId = ''
                queryBy_md5Id(this.metadataForm.metaDataSourceId.md5Id).then((res) => {
                    if (res.code == '1') {
                        this.dataBaseIdOptions = res.data
                    }
                })
            },

            //发送的数据格式化
            formatData() {
                let param = cloneDeep(this.metadataForm)

                if (param.dataSourceType == 'hive') {
                    param.metaColumns = param.metaColumns.concat(param.metaPartColumns)
                    param.metaColumns.forEach((item) => {
                        if (item.columnType == 'boolean') {
                            item.columnLength = null
                        }
                    })
                }

                param.metaMysqlIndexUpdateVos.forEach((item) => {
                    if (typeof (item.metaColumns) == 'string') {
                        item.metaColumns = [{ columnName: item.metaColumns }]
                    } else {
                        item.metaColumns = item.metaColumns.map((item2) => {
                            return { columnName: item2 }
                        })
                    }
                })
                return param
            },

            drag() {
                const el = document.querySelectorAll(
                  '.el-form > div > .el-table > .el-table__body-wrapper > table > tbody'
                )
                for (let i = 0; i < 2; i++) {
                    Sortable.create(el[i], {
                        disabled: false, // 拖拽不可用? false 启用
                        handle: '.move',
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = this.metadataForm.metaColumns // 获取表数据
                            if (i == 1) {
                                arr = this.metadataForm.metaMysqlIndexUpdateVos
                            }
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]) // 数据处理，获取最新的表格数据
                        }
                    })
                }
            },
            //主键复选监听
            primaryChange(row) {
                if ('oldIndex' in row && row.flag != 2) {
                    row.flag = 2
                }
                row.columnIfNull = row.isPrimary == 1 ? 1 : 0
            },
            //各种单纯输入框更改
            currencyChange(row) {
                console.log(row)
                if ('oldIndex' in row && row.flag != 2) {
                    row.flag = 2
                }
            },
            //字段类型更改
            columnTypeChange(row) {
                if ('oldIndex' in row && row.flag != 2) {
                    row.flag = 2
                }
                row.columnIfIncy = 1
            },
            //placeholder
            getPlace(scope) {

                let columnType = scope.row.columnType

                //键值对匹配

                let mysqlLength = columnType == 'TINYINT' ? '1 byte' : columnType == 'SMALLINT' ? '2 bytes' : columnType == 'MEDIUMINT' ? '3 bytes' : columnType == 'INT' ? '4 bytes' : columnType == 'INTEGER' ? '4 bytes' :
                  columnType == 'BIGINT' ? '8 bytes' : columnType == 'FLOAT' ? '4 bytes' : columnType == 'DOUBLE' ? '8 bytes' : columnType == 'DECIMAL' ? '' : columnType == 'DATE' ? '3' : columnType == 'TIME' ? '3' :
                    columnType == 'YEAR' ? '1 byte' : columnType == 'DATETIME' ? '8' : columnType == 'TIMESTAMP' ? '4' : columnType == 'CHAR' ? '0-255 bytes' : columnType == 'VARCHAR' ? '0-65535 bytes' :
                      columnType == 'TINYBLOB' ? '0-255 bytes' : columnType == 'TINYTEXT' ? '0-255 bytes' : columnType == 'BLOB' ? '0-65  535 bytes' : columnType == 'TEXT' ? '0-65  535 bytes' : columnType == 'MEDIUMBLOB' ? '0-16 777 215 bytes' :
                        columnType == 'MEDIUMTEXT' ? '0-16 777 215 bytes' : columnType == 'LONGBLOB' ? '0-4 294 967 295 bytes' : columnType == 'LONGTEXT' ? '0-4 294 967 295 bytes' : ''

                return mysqlLength
            }

        }
    }
</script>

<style lang="scss" scoped>
    .tableName {
        display: flex;
        margin-bottom: 10px;

        .table-input {
            .el-form-item__content {
                margin-left: 0px;
            }
        }
    }

    .formDia ::v-deep.el-dialog__body {
        overflow: auto;
    }

    .add_but {
        margin: 15px;
    }

    .step_content {
        max-height: 600px;
    }

    .step_3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px;
        font-size: 18px;

        .title {
            padding: 20px;
        }

        .table_name {
            padding: 10px;
        }

        .table_index {
            padding: 10px;

            .index_item {
                margin: 0 5px;
            }
        }
    }

    .sortable-ghost {
        opacity: 0.4;
        background-color: #f4e2c9;
    }

    .move {
        cursor: move;
        font-size: 20px;
    }

    .un_move {
        cursor: no-drop;
        font-size: 20px;
    }
</style>
